const getTimestamp = (date, time) => date + 'T' + time;

export default getTimestamp;
